import React from 'react';
import { Redirect } from 'react-router';
import { ERoutesPublic } from 'common/models/routesModel';

export const RootPublicPage: React.FC = () => {
  return <Redirect to={ERoutesPublic.Login} />;
};
